import { useCallback } from 'react';
import { AccountPremiumToast } from '../account/AccountPremiumToast';
import { useAccountToast } from '../../features/wallet/hooks/useWalletTransferNotifications';

/** Top-right toasts for auth screens (keeps errors outside the sign-in card). */
export function useAuthFormToast() {
  const { toast, showError, showSuccess, showWarning, closeToast } = useAccountToast();

  const ToastHost = useCallback(
    () => (
      <AccountPremiumToast
        toast={toast}
        onClose={closeToast}
        placement="top-right"
        appearance="light"
      />
    ),
    [toast, closeToast]
  );

  return { showError, showSuccess, showWarning, ToastHost };
}
